import React, { useEffect } from "react";
import ExamCorrectionAdmin from "../../components/APanel/ExamCorrectionAdmin";

export default function APExamCorrection() {
   useEffect(() => {
      document.title = "Instruire Auto | Corectare Exam";
   }, []);

   return (
      <main className="main">
         <ExamCorrectionAdmin />
      </main>
   );
}
